import { useSearchPageData } from 'src/app/pages/search/pageContext';

type Result = ModelHookResult<{
	isUnderMaintenance: boolean;
}>;

export function useUnderMaintenance(): Result {
	const {
		data: { featureConfigs },
	} = useSearchPageData();
	const { isUnderMaintenance } = featureConfigs;

	return {
		data: {
			isUnderMaintenance,
		},
	};
}
